// extracted by mini-css-extract-plugin
module.exports = {"layout":"page_100mm_50mm_1_label_layout__2GhWD"};